import type React from 'react'
import styled from 'styled-components'

import InformationItem from '@/components/EntityPanels/InformationItem'
import type { CompanyFinance } from '@/types/Activity'

import { toMonetaryValue } from './utils'
interface Props {
  finance: CompanyFinance
}

const VerifiedBy = styled.p`
  margin: 0;
`

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
`

const OrganisationFinanceDetails: React.FC<Props> = ({ finance }) => {
  return (
    <div>
      <h2>Not For Profit Company</h2>
      {finance?.verifiedBy !== undefined && (
        <VerifiedBy>
          The organisation details has been verified by{' '}
          <strong>{finance.verifiedBy.name}</strong> ({finance.verifiedBy.email})
        </VerifiedBy>
      )}
      <DetailRow>
        <InformationItem header="Assets">
          <p>£{toMonetaryValue(finance.assets)}</p>
        </InformationItem>
        <InformationItem header="Cash and Equivalent">
          <p>£{toMonetaryValue(finance.cashAndEquivalent)}</p>{' '}
        </InformationItem>
        <InformationItem header="Liabilities">
          <p>£{toMonetaryValue(finance.liabilities)}</p>{' '}
        </InformationItem>
        <InformationItem header="Unrestricted Funds">
          <p>£{toMonetaryValue(finance.unrestrictedFunds)}</p>{' '}
        </InformationItem>
        <InformationItem header="Net Assets">
          <p>£{toMonetaryValue(finance.netAssets)}</p>{' '}
        </InformationItem>
        <InformationItem header="Current Ratio">
          <p>{finance.currentRatio.toFixed(2)}</p>{' '}
        </InformationItem>
      </DetailRow>
    </div>
  )
}

export default OrganisationFinanceDetails
